module.exports = __webpack_public_path__ + "static/img/07.b7d747dc.png";